import { Component, computed, inject, input } from '@angular/core';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

export enum MyBetsTextBadgeModel {
    EarlyPayout = 'EarlyPayout',
}

@Component({
    selector: 'ms-my-bets-text-badge',
    template: `
        @if (badgeText()) {
            <span class="mybets-text-badge"> {{ badgeText() }} </span>
        }
    `,
    styleUrl: 'my-bets-text-badge.component.scss',
    standalone: true,
})
export class MyBetsTextBadgeComponent {
    badgeKind = input.required<MyBetsTextBadgeModel>();
    badgeText = computed(() => {
        if (this.badgeKind() === MyBetsTextBadgeModel.EarlyPayout) {
            return this.sitecoreMyBets.myBets.EarlyPayoutTextBadge;
        }
        return '';
    });
    private sitecoreMyBets = inject(SitecoreMyBetsConfig);
}
